import { Controller } from '@hotwired/stimulus'
import CompanyDeleteConfirmController from '@/public/blocks/CompanyDeleteConfirm/controller'

export default class extends Controller {
    static targets = ['deleteModal']

    declare readonly deleteModalTarget: HTMLElement

    private deleteConfirmController: CompanyDeleteConfirmController | null = null

    async setDefault(event: Event): Promise<void> {
        const checkbox = event.target as HTMLInputElement
        const companyId = checkbox.getAttribute('data-company-id')

        if (!companyId) {
            return
        }

        checkbox.checked = true

        const response = await fetch(`/api/buyer/companies/${companyId}/default`, {
            method: 'PUT',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
        })

        if (!response.ok) {
            checkbox.checked = false
            return
        }

        this.element.querySelectorAll('.company-list__item').forEach(item => {
            const itemEl = item as HTMLElement
            const isClicked = itemEl.getAttribute('data-company-id') === companyId

            const badge = itemEl.querySelector('.company-list__item--badge') as HTMLElement
            const deleteBtn = itemEl.querySelector('.company-list__item--delete') as HTMLElement
            const cb = itemEl.querySelector('input[type="checkbox"]') as HTMLInputElement

            cb.checked = isClicked
            badge?.classList.toggle('hidden', !isClicked)
            deleteBtn?.classList.toggle('hidden', isClicked)
        })
    }

    deleteCompany(event: Event): void {
        const button = event.currentTarget as HTMLElement
        const companyId = button.getAttribute('data-company-id')

        if (!companyId) {
            return
        }

        this.resolveDeleteConfirmController()?.open(Number(companyId))
    }

    private resolveDeleteConfirmController(): CompanyDeleteConfirmController|null
    {
        if (!this.deleteConfirmController) {
            this.deleteConfirmController = this.application.getControllerForElementAndIdentifier(
                this.deleteModalTarget,
                'company-delete-confirm'
            ) as CompanyDeleteConfirmController | null
        }

        return this.deleteConfirmController
    }
}
